import React from 'react';
import type { CallPutEnum } from 'venn-api';
import styled from 'styled-components';

type OptionIconProps = Readonly<{
  optionType: CallPutEnum;
  inverted?: boolean;
}>;

export const CALL_OPTION_ICON_CONTENT = '\uE101';
export const PUT_OPTION_ICON_CONTENT = '\uE11A';

const StyledTSpan = styled.tspan`
  font-family: 'Font Awesome 5 Pro', 'Font Awesome 6 Pro', 'FAP';
  font-weight: 900;
  fill: ${(props) => props.theme.Colors.GreyScale.Grey60};
`;

export const OptionIconSVG = ({ optionType }: OptionIconProps) => {
  if (optionType === 'UNKNOWN') {
    return null;
  }

  return (
    <StyledTSpan data-testid={optionType === 'CALL' ? 'call-option-icon-svg' : 'put-option-icon-svg'}>
      {optionType === 'CALL' ? CALL_OPTION_ICON_CONTENT : PUT_OPTION_ICON_CONTENT}
    </StyledTSpan>
  );
};
